import * as React from 'react';
const SvgArrowShort = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="1em" height="1em" viewBox="0 0 9 16" fill="#1A1A1A" {...props}>
        <path d="M8.707 14.293a1 1 0 11-1.414 1.414L.646 9.061a1.5 1.5 0 010-2.122L7.293.293a1 1 0 011.414 1.414L2.414 8l6.293 6.293z" />
    </svg>
);
export default SvgArrowShort;
